import { Icon, SvgForward5 } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';

import { skipForward } from 'creators/videoPlayer';

import ControlBarButton from '../control-bar-button';

import './styles.less';

export default function StepForwardFiveButton(props) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(skipForward());
  };

  return (
    <ControlBarButton
      className={classNames('step-forward-five-button', {
        'crowded-embed': props.crowded && !props.isMainVideoOnSharePage,
      })}
      hoverTagText="Step Forward (l)"
      seeking={props.seeking}
      onClick={handleClick}
    >
      <Icon
        color="white"
        className="control-bar-button-icon"
        icon={<SvgForward5 />}
      />
    </ControlBarButton>
  );
}
